// DE translations for Surplify.
// Maintained as a per-language file. See ../i18n.js for init logic.

const de = {
  "app.title": "Surplify",
  "nav.home": "Startseite",
  "nav.search": "Suchen",
  "nav.watchlist": "Merkliste",
  "nav.requests": "Meine Anfragen",
  "nav.dashboard": "Dashboard",
  "nav.admin": "Admin",
  "nav.import": "Importieren",
  "nav.myMaterials": "Meine Artikel",
  "nav.login": "Anmelden",
  "nav.register": "Registrieren",
  "nav.logout": "Abmelden",
  "material.request": "Material anfragen",
  "material.addToWatchlist": "Zur Merkliste",
  "material.removeFromWatchlist": "Von Merkliste entfernen",
  "status.reserved": "Reserviert",
  "status.pending": "Ausstehend",
  "status.approved": "Genehmigt",
  "status.rejected": "Abgelehnt",
  "status.completed": "Abgeschlossen",
  "badge.groupOnly": "Nur Gruppe",
  "badge.external": "Extern",
  "badge.slowMoving": "Langsam drehend",
  "badge.nonMoving": "Nicht drehend",
  "badge.missingDocs": "Dokumente fehlen",
  "filter.category": "Kategorie",
  "filter.site": "Standort",
  "filter.age": "Altersgruppe",
  "filter.manufacturer": "Hersteller",
  "filter.price": "Preis",
  "filter.width": "Breite",
  "filter.country": "Land",
  "filter.allCountries": "Alle Länder",
  "filter.advancedFilters": "Erweiterte Filter",
  "filter.basicFilters": "Filter",
  "filter.technicalSpecs": "Technische Spezifikationen",
  "filter.materialProperties": "Materialeigenschaften",
  "filter.stockDetails": "Lagerdetails",
  "filter.widthRange": "Breitenbereich",
  "filter.thicknessRange": "Dickenbereich",
  "filter.coreDiameter": "Kerndurchmesser",
  "filter.certifications": "Zertifizierungen",
  "filter.customerSpecific": "Kundenspezifisch",
  "filter.complianceFlag": "Compliance-Flag",
  "filter.compliant": "Konform",
  "filter.minQuantity": "Mindestmenge",
  "filter.ageBucket": "Lageralter",
  "filter.age_0_90": "< 3 Monate",
  "filter.age_91_180": "3-6 Monate",
  "filter.age_181_360": "6-12 Monate",
  "filter.age_gt_360": "> 12 Monate",
  "filter.min": "Min",
  "filter.max": "Max",
  "filter.both": "Beide",
  "filter.yes": "Ja",
  "filter.no": "Nein",
  "filter.quantity": "Menge",
  "filter.clearAll": "Alle löschen",
  "filter.clearFilters": "Filter löschen",
  "filter.clearAllFilters": "Alle Filter löschen",
  "filter.filters": "Filter",
  "filter.thickness": "Dicke",
  "filter.core": "Kern",
  "filter.qty": "Menge",
  "search.resultsFor": "Ergebnisse für",
  "search.allMaterials": "Alle Materialien",
  "search.materialsFound": "Materialien gefunden",
  "search.filtering": "Filtern...",
  "search.tryAdjusting": "Versuchen Sie, Ihre Filter oder Suchbegriffe anzupassen",
  "sort.sortBy": "Sortieren nach",
  "sort.newestFirst": "Neueste zuerst",
  "sort.oldestFirst": "Älteste zuerst",
  "sort.priceLowHigh": "Preis: Niedrig bis Hoch",
  "sort.priceHighLow": "Preis: Hoch bis Niedrig",
  "sort.quantityHighLow": "Menge: Hoch bis Niedrig",
  "pagination.previous": "Zurück",
  "pagination.next": "Weiter",
  "preset.presets": "Voreinstellungen",
  "preset.savePreset": "Filter-Voreinstellung speichern",
  "preset.saveDescription": "Geben Sie Ihrer Filterkombination einen Namen, um sie später schnell anzuwenden.",
  "preset.name": "Name der Voreinstellung",
  "preset.namePlaceholder": "z.B. FSC Folien > 100mm",
  "preset.nameRequired": "Bitte geben Sie einen Namen ein",
  "preset.saved": "Voreinstellung gespeichert",
  "preset.saveFailed": "Speichern fehlgeschlagen",
  "preset.applied": "Voreinstellung \"{name}\" angewendet",
  "preset.applyFailed": "Anwenden fehlgeschlagen",
  "preset.renamed": "Voreinstellung umbenannt",
  "preset.renameFailed": "Umbenennen fehlgeschlagen",
  "preset.deleted": "Voreinstellung gelöscht",
  "preset.deleteFailed": "Löschen fehlgeschlagen",
  "preset.renamePreset": "Voreinstellung umbenennen",
  "preset.newName": "Neuer Name",
  "preset.deleteConfirm": "Voreinstellung löschen?",
  "preset.deleteDescription": "Die Voreinstellung \"{name}\" wird dauerhaft gelöscht.",
  "preset.noPresets": "Keine gespeicherten Voreinstellungen",
  "preset.saveHint": "Filter anwenden und speichern",
  "preset.filters": "Filter",
  "preset.used": "Voreinstellungen verwendet",
  "preset.rename": "Umbenennen",
  "preset.delete": "Löschen",
  "preset.noFiltersToSave": "Keine aktiven Filter zum Speichern",
  "preset.maxReached": "Maximum erreicht",
  "preset.saveCurrentFilters": "Aktuelle Filter speichern",
  "preset.filtersWillBeSaved": "Filter werden gespeichert",
  "status.pendingApproval": "Freigabe ausstehend",
  "admin.materialApprovals": "Material-Freigabe",
  "admin.materialApprovalsDesc": "Externe Materialien prüfen und freigeben",
  "admin.noPendingMaterials": "Keine ausstehenden Material-Freigaben",
  "admin.submittedBy": "Eingereicht von",
  "admin.approve": "Freigeben",
  "admin.reject": "Ablehnen",
  "common.search": "Materialien suchen...",
  "common.loading": "Laden...",
  "common.noResults": "Keine Ergebnisse",
  "common.save": "Speichern",
  "common.cancel": "Abbrechen",
  "common.submit": "Absenden",
  "common.close": "Schließen",
  "common.back": "Zurück",
  "common.saving": "Speichern...",
  "common.create": "Erstellen",
  "home.newListings": "Neue Einträge",
  "home.highValue": "Hochwertiger Bestand",
  "home.featured": "Ausgewählte Materialien",
  "auth.email": "E-Mail",
  "auth.password": "Passwort",
  "auth.name": "Vollständiger Name",
  "auth.loginTitle": "Anmelden",
  "auth.registerTitle": "Konto erstellen",
  "auth.noAccount": "Noch kein Konto?",
  "auth.hasAccount": "Bereits ein Konto?",
  "auth.registrationSuccess": "Registrierung erfolgreich!",
  "auth.pendingApproval": "Ihr Konto wurde erstellt und wartet auf die Admin-Genehmigung. Sie können die vollständigen Materialdetails sehen, sobald Ihr Konto genehmigt wurde.",
  "auth.registerDesc": "Erstellen Sie ein Konto um mit dem Materialhandel zu beginnen",
  "auth.companyGroup": "Firmengruppe",
  "auth.selectCompanyGroup": "Wählen Sie Ihre Firmengruppe...",
  "auth.site": "Werk / Standort",
  "auth.selectSite": "Wählen Sie Ihr Werk...",
  "myMaterials.title": "Meine Werk-Artikel",
  "myMaterials.articles": "Artikel",
  "myMaterials.bulkUpload": "Massenupload",
  "myMaterials.newArticle": "Neuer Artikel",
  "myMaterials.searchPlaceholder": "Artikel suchen...",
  "myMaterials.allStatuses": "Alle Status",
  "myMaterials.statusArchived": "Archiviert",
  "myMaterials.empty": "Keine Artikel gefunden",
  "myMaterials.emptyDesc": "In Ihrem Werk wurden noch keine Artikel eingestellt.",
  "myMaterials.you": "Sie",
  "myMaterials.quantity": "Menge",
  "myMaterials.value": "Wert",
  "myMaterials.archive": "Archivieren",
  "myMaterials.deleteTitle": "Material löschen?",
  "myMaterials.deleteDesc": "Das Material und alle zugehörigen Bestände werden unwiderruflich gelöscht.",
  "myMaterials.archiveTitle": "Material archivieren?",
  "myMaterials.archiveDesc": "Das Material wird archiviert und ist nicht mehr im Marktplatz sichtbar.",
  "myMaterials.deleted": "Material gelöscht",
  "myMaterials.archived": "Material archiviert",
  "myMaterials.noSite": "Ihrem Konto ist kein Werk zugewiesen.",
  "myMaterials.noSiteTitle": "Kein Werk zugewiesen",
  "myMaterials.noSiteDesc": "Bitte wenden Sie sich an einen Administrator, um einem Werk zugewiesen zu werden.",
  "dashboard.totalInventory": "Gesamtbestand",
  "dashboard.slowMoving": "Langsam drehend (>180 Tage)",
  "dashboard.nonMoving": "Nicht drehend (>360 Tage)",
  "dashboard.pendingRequests": "Offene Anfragen",
  "dashboard.monthlyTransfers": "Monatliche Transfers",
  "dashboard.overdueItems": "Überfällige Artikel",
  "dashboard.subtitle": "Globale Bestandsübersicht",
  "dashboard.siteFilter": "Nach Standort filtern",
  "dashboard.allSites": "Alle Standorte",
  "dashboard.slowMovingDesc": "Materialien 181-360 Tage alt",
  "dashboard.nonMovingDesc": "Materialien über 360 Tage alt",
  "dashboard.transfersDesc": "Interne Transfers diesen Monat",
  "dashboard.overdueDesc": "Artikel erfordern Aufmerksamkeit",
  "dashboard.ageChart": "Bestand nach Alter",
  "dashboard.ageChartDesc": "Verteilung des Bestandswerts nach Altersgruppe",
  "dashboard.siteRanking": "Standort-Ranking",
  "dashboard.siteRankingDesc": "Standorte mit den meisten langsam drehenden Beständen",
  "dashboard.overdueTitle": "Überfällige Artikel (>360 Tage)",
  "dashboard.overdueDesc2": "Diese Artikel erfordern sofortige Aufmerksamkeit",
  "dashboard.viewAllOverdue": "Alle {{count}} überfällige Artikel anzeigen",
  "dashboard.viewNonMoving": "Nicht drehende Bestände anzeigen",
  "dashboard.pendingRequestsLink": "Offene Anfragen",
  "dashboard.importMaterials": "Materialien importieren",
  "dashboard.age0_90": "0-90 Tage",
  "dashboard.age91_180": "91-180 Tage",
  "dashboard.age181_360": "181-360 Tage",
  "dashboard.ageGt360": ">360 Tage",
  "dashboard.slowMovingItems": "Langsam drehende Artikel",
  "dashboard.totalMaterials": "Gesamtmaterialien",
  "dashboard.totalMaterialsDesc": "Aktive Materialien im Bestand",
  "dashboard.externalSales": "Externe Verkäufe",
  "dashboard.externalSalesDesc": "Externe Verkäufe diesen Monat",
  "dashboard.sitePending": "Offene Anfragen",
  "dashboard.sitePendingDesc": "Offene Anfragen für diesen Standort",
  "import.title": "Materialien importieren",
  "import.subtitle": "Material-Daten per Excel importieren & exportieren",
  "import.downloadTemplate": "Vorlage herunterladen",
  "import.uploadFile": "Datei hochladen",
  "import.validate": "Validieren",
  "import.execute": "Import ausführen",
  "import.mode.overwrite": "Alles überschreiben",
  "import.mode.enrich": "Nur ergänzen",
  "import.mode.selective": "Felder auswählen",
  "import.export": "Export",
  "import.exportTitle": "Materialien exportieren",
  "import.exportDesc": "Material-Daten als Excel-Datei mit optionalen Filtern herunterladen",
  "import.exportDownload": "Excel herunterladen",
  "bulk.title": "Sammel-Upload",
  "bulk.subtitle": "Mehrere Materialien per Excel/CSV importieren",
  "bulk.downloadTemplate": "Vorlage herunterladen",
  "bulk.dropHint": "Excel/CSV-Datei hier ablegen oder klicken",
  "bulk.browse": "Datei auswaehlen",
  "bulk.templateDownloaded": "Vorlage heruntergeladen",
  "bulk.templateError": "Vorlage konnte nicht heruntergeladen werden",
  "bulk.rowsLoaded": "{{count}} Zeilen geladen",
  "bulk.parseError": "Datei konnte nicht gelesen werden",
  "bulk.invalidFile": "Ungueltiges Format. Bitte .xlsx, .xls oder .csv verwenden",
  "bulk.rows": "Zeilen",
  "bulk.moreRows": "weitere Zeilen",
  "bulk.validate": "Daten validieren",
  "bulk.validating": "Wird validiert...",
  "bulk.valid": "Gueltig",
  "bulk.errors": "Fehler",
  "bulk.duplicates": "Vorhanden (Update)",
  "bulk.newItems": "Neue Eintraege",
  "bulk.validationErrors": "Validierungsfehler",
  "bulk.rowError": "Zeile {{row}}",
  "bulk.importMode": "Import-Modus fuer Duplikate",
  "bulk.modeEnrich": "Anreichern",
  "bulk.modeEnrichDesc": "Nur leere Felder fuellen, bestehende Daten behalten",
  "bulk.modeOverwrite": "Ueberschreiben",
  "bulk.modeOverwriteDesc": "Alle Felder mit importierten Werten ersetzen",
  "bulk.executeImport": "{{count}} Zeilen importieren",
  "bulk.importing": "Wird importiert...",
  "bulk.importComplete": "Import abgeschlossen!",
  "bulk.created": "Erstellt",
  "bulk.updated": "Aktualisiert",
  "bulk.enriched": "Angereichert",
  "bulk.rejected": "Abgelehnt",
  "bulk.importMore": "Weiteren Import starten",
  "bulk.importError": "Import fehlgeschlagen",
  "bulk.validateError": "Validierung fehlgeschlagen",
  "bulk.col.manufacturer_name": "Hersteller",
  "bulk.col.manufacturer_part_number": "Hersteller-Nr.",
  "bulk.col.article_number": "Artikel-Nr.",
  "bulk.col.quantity": "Menge",
  "bulk.col.uom": "Einheit",
  "bulk.col.number_of_rolls": "Rollen",
  "bulk.col.notes_internal": "Bemerkung",
  "request.title": "Material anfragen",
  "request.quantity": "Menge",
  "request.message": "Nachricht (optional)",
  "request.type.internal": "Interner Transfer",
  "request.type.external": "Externe Anfrage",
  "requests.tab.my": "Meine Anfragen",
  "requests.tab.incoming": "Eingehende Anfragen",
  "requests.details": "Anfrage-Details",
  "requests.detail.article": "Artikel",
  "requests.detail.quantity": "Angefragte Menge",
  "requests.detail.type": "Typ",
  "requests.detail.requestedBy": "Angefragt von",
  "requests.detail.date": "Datum",
  "requests.detail.message": "Nachricht",
  "requests.from": "Von",
  "requests.viewDetails": "Details anzeigen",
  "requests.loginRequired": "Anmeldung erforderlich",
  "requests.loginHint": "Bitte melden Sie sich an, um Ihre Anfragen zu sehen",
  "requests.empty.my": "Keine Anfragen gesendet",
  "requests.empty.myHint": "Sie haben noch keine Anfragen gestellt. Durchsuchen Sie Materialien und senden Sie eine Anfrage!",
  "requests.empty.incoming": "Keine eingehenden Anfragen",
  "requests.empty.incomingHint": "Sie haben keine eingehenden Anfragen für Ihre Materialien.",
  "requests.action.approve": "Genehmigen",
  "requests.action.reject": "Ablehnen",
  "requests.action.complete": "Abschließen",
  "requests.action.approveTitle": "Anfrage genehmigen",
  "requests.action.rejectTitle": "Anfrage ablehnen",
  "requests.action.completeTitle": "Anfrage abschließen",
  "requests.action.approveDesc": "Die Anfrage wird genehmigt und das Material für den Anfragenden reserviert.",
  "requests.action.rejectDesc": "Die Anfrage wird abgelehnt. Der Anfragende wird benachrichtigt.",
  "requests.action.completeDesc": "Der Transfer wird abgeschlossen und die Bestandsmengen werden aktualisiert.",
  "requests.action.approvedSuccess": "Anfrage genehmigt",
  "requests.action.rejectedSuccess": "Anfrage abgelehnt",
  "requests.action.completedSuccess": "Anfrage abgeschlossen - Bestand aktualisiert",
  "requests.action.failed": "Fehler beim Aktualisieren der Anfrage",
  "restricted.title": "Eingeschränkter Inhalt",
  "restricted.loginHint": "Bitte melden Sie sich an, um Preise, Mengen und Standortdetails zu sehen.",
  "restricted.approvalHint": "Ihr Konto wartet auf Genehmigung. Ein Administrator wird Ihre Registrierung in Kürze prüfen.",
  "restricted.cardHint": "Anmelden und Genehmigung erhalten um Details zu sehen",
  "admin.users": "Benutzer",
  "admin.usersDesc": "Benutzerregistrierungen und Genehmigungen verwalten",
  "admin.noUsers": "Keine Benutzer gefunden",
  "admin.approved": "Genehmigt",
  "admin.pending": "Ausstehend",
  "admin.registeredAt": "Registriert",
  "admin.approveUser": "Genehmigen",
  "admin.revokeUser": "Widerrufen",
  "admin.userApproved": "Benutzer erfolgreich genehmigt",
  "admin.userRevoked": "Benutzerzugang widerrufen",
  "admin.userApproveFailed": "Fehler beim Aktualisieren des Benutzerstatus",
  "admin.deleteUser": "Benutzer löschen",
  "admin.deleteUserTitle": "Benutzer löschen",
  "admin.deleteUserConfirm": "Möchten Sie den Benutzer {{name}} ({{email}}) wirklich endgültig löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  "admin.userDeleted": "Benutzer erfolgreich gelöscht",
  "admin.userDeleteFailed": "Fehler beim Löschen des Benutzers",
  "admin.categoryTree": "Kategoriebaum",
  "admin.categoryTreeDesc": "Produktkategorien und ihre Hierarchie verwalten",
  "admin.addCategory": "Kategorie hinzufügen",
  "admin.editCategory": "Kategorie bearbeiten",
  "admin.deleteCategory": "Kategorie löschen",
  "admin.addCategoryDesc": "Neue Produktkategorie erstellen",
  "admin.editCategoryDesc": "Name, übergeordnete Kategorie oder Sortierung bearbeiten",
  "admin.deleteCategoryConfirm": "Sind Sie sicher, dass Sie \"{{name}}\" löschen möchten? Die Kategorie wird deaktiviert und aus den Listen ausgeblendet.",
  "admin.categoryName": "Kategoriename",
  "admin.categoryNamePlaceholder": "z.B. Folien & Filme",
  "admin.parentCategory": "Übergeordnete Kategorie",
  "admin.noParent": "Keine (Hauptebene)",
  "admin.sortOrder": "Sortierreihenfolge",
  "admin.categoryCreated": "Kategorie erstellt",
  "admin.categoryUpdated": "Kategorie aktualisiert",
  "admin.categoryDeleted": "Kategorie deaktiviert",
  "admin.categoryCreateFailed": "Kategorie konnte nicht erstellt werden",
  "admin.categoryUpdateFailed": "Kategorie konnte nicht aktualisiert werden",
  "admin.categoryDeleteFailed": "Kategorie konnte nicht gelöscht werden",
  "admin.noCategoriesFound": "Keine Kategorien gefunden. Klicken Sie auf \"Seed Sample Data\" um Standardkategorien zu laden.",
  "admin.defaultImage": "Standardbild",
  "admin.uploadDefaultImage": "Bild hochladen",
  "admin.delete": "Löschen",
  "create.newTitle": "Material einstellen",
  "create.editTitle": "Material bearbeiten",
  "create.materialInfo": "Material-Informationen",
  "create.title": "Titel",
  "create.titlePlaceholder": "z.B. PE-Folie 500mm transparent",
  "create.description": "Beschreibung",
  "create.descPlaceholder": "Detaillierte Beschreibung des Materials...",
  "create.selectCategory": "Kategorie wählen",
  "create.companyGroup": "Unternehmensgruppe",
  "create.selectGroup": "Gruppe wählen",
  "create.partNumber": "Teilenummer",
  "create.thickness": "Dicke",
  "create.grade": "Material-Güte",
  "create.coreDiameter": "Kerndurchmesser",
  "create.materialIndex": "Material-Index",
  "create.erpArticleNumber": "ERP-Artikelnummer",
  "create.skuInfo": "Bestandsdaten (SKU)",
  "create.addSku": "Bestand hinzufügen",
  "create.addMore": "Weitere SKU",
  "create.selectSite": "Standort wählen",
  "create.articleNumber": "Artikelnummer",
  "create.rolls": "Anzahl Rollen",
  "create.bookValue": "Buchwert",
  "create.listPrice": "Listenpreis",
  "create.productionDate": "Produktionsdatum",
  "create.customerSpecific": "Kundenspezifisch",
  "create.compliant": "Konform",
  "create.notesInternal": "Interne Notizen",
  "create.notesInternalPlaceholder": "Nur intern sichtbar...",
  "create.publish": "Veröffentlichen",
  "create.materialCreated": "Material erfolgreich erstellt",
  "create.materialUpdated": "Material erfolgreich aktualisiert",
  "create.existingSkus": "Vorhandene Bestände",
  "create.noNewSkus": "Keine neuen Bestände hinzugefügt",
  "create.previewHint": "Vorschau des Materials",
  "create.untitled": "Unbenanntes Material",
  "create.titleRequired": "Titel ist erforderlich",
  "create.categoryRequired": "Kategorie ist erforderlich",
  "create.manufacturerRequired": "Hersteller ist erforderlich",
  "create.partNumberRequired": "Teilenummer ist erforderlich",
  "create.groupRequired": "Unternehmensgruppe ist erforderlich",
  "create.siteRequired": "Standort ist erforderlich",
  "create.articleRequired": "Artikelnummer ist erforderlich",
  "create.quantityRequired": "Menge ist erforderlich",
  "create.saveError": "Fehler beim Speichern",
  "create.photos": "Fotos",
  "create.addPhoto": "Foto",
  "create.documents": "Dokumente (PDF)",
  "create.addDocument": "PDF-Dokument hinzufügen",
  "create.techSpec": "Technisches Datenblatt",
  "create.techSpecHint": "Mindestens ein technisches Datenblatt (PDF) ist erforderlich. Käufer benötigen die Spezifikation zur Materialprüfung.",
  "create.techSpecRequired": "Pflichtfeld",
  "create.addTechSpec": "Technisches Datenblatt (PDF) hochladen",
  "create.techSpecRequiredError": "Bitte laden Sie ein technisches Datenblatt (PDF) hoch, bevor Sie speichern.",
  "admin.masterData": "Stammdaten",
  "masterData.searchPlaceholder": "Suche nach Lieferant, Artikelnr...",
  "masterData.matchesFound": "Stammdaten gefunden",
  "masterData.applied": "Stammdaten angewendet",
  "masterData.appliedLabel": "Stammdaten angewendet",
  "watchlist.loginRequired": "Anmeldung erforderlich",
  "watchlist.loginHint": "Bitte melden Sie sich an, um Ihre Merkliste zu sehen",
  "watchlist.empty": "Ihre Merkliste ist leer",
  "watchlist.emptyHint": "Durchsuchen Sie Materialien und klicken Sie auf das Herz-Symbol",
  "watchlist.browse": "Materialien durchsuchen",
  "watchlist.remove": "Entfernen",
  "watchlist.priceOnRequest": "Preis auf Anfrage",
  "watchlist.addedOn": "Hinzugefügt am",
  "watchlist.itemCount": "{{count}} Artikel auf Ihrer Merkliste",
  "sustainability.title": "Nachhaltigkeitswirkung",
  "sustainability.subtitle": "Abfallvermeidung durch intelligente Materialumverteilung",
  "sustainability.heroTagline": "Kreislaufwirtschaft für Verpackungen",
  "sustainability.heroDesc": "Jedes umverteilte Material ist eines weniger, das von Grund auf neu produziert werden muss. Gemeinsam reduzieren wir CO2, schonen Ressourcen und bauen ein zirkuläres Fertigungsökosystem auf.",
  "sustainability.co2Saved": "CO2 eingespart",
  "sustainability.co2SavedDesc": "Geschätzte vermiedene Emissionen",
  "sustainability.materialsRedistributed": "Materialien umverteilt",
  "sustainability.materialsRedistributedDesc": "Erfolgreich zwischen Standorten transferiert",
  "sustainability.valueSaved": "Wert erhalten",
  "sustainability.valueSavedDesc": "Betriebskapital vor Verschwendung bewahrt",
  "sustainability.activeSites": "Aktive Standorte",
  "sustainability.activeSitesDesc": "Standorte beteiligen sich an der Umverteilung",
  "sustainability.circularRate": "Kreislaufwirtschaftsrate",
  "sustainability.circularRateDesc": "Materialien mit zweitem Leben",
  "sustainability.atRisk": "Gefährdete Materialien",
  "sustainability.atRiskDesc": "Langsam/nicht drehende Bestände, die umverteilt werden könnten",
  "sustainability.pendingRedist": "Laufende Umverteilungen",
  "sustainability.pendingRedistDesc": "Transfers werden derzeit bearbeitet",
  "sustainability.availableForReuse": "Verfügbar zur Wiederverwendung",
  "sustainability.impactBanner": "Gemeinsam vermeiden wir Verpackungsabfall und schonen Ressourcen",
  "sustainability.kgUnit": "kg",
  "sustainability.tonUnit": "t",
  "sustainability.downloadReport": "ESG-Bericht herunterladen",
  "sustainability.downloadReportDesc": "PDF-Nachhaltigkeitsbericht für das Management erstellen",
  "sustainability.reportGenerating": "Bericht wird erstellt...",
  "sustainability.reportReady": "ESG-Bericht erfolgreich heruntergeladen",
  "sustainability.reportError": "Fehler beim Erstellen des Berichts",
  "admin.title": "Administration",
  "admin.scenarios": "Szenarien",
  "admin.scenariosTitle": "Szenario-Konfiguration",
  "admin.scenariosDesc": "Governance-Regeln und Genehmigungsworkflows konfigurieren",
  "admin.scenarioMode": "Szenario-Modus",
  "admin.internalWindow": "Internes Fenster (Tage)",
  "admin.internalWindowDesc": "Tage, die Artikel nur intern sichtbar sind",
  "admin.escalationDays": "Eskalationstage",
  "admin.escalationDaysDesc": "Tage vor Eskalationsbenachrichtigungen",
  "admin.externalEnabled": "Externe Veröffentlichung aktiviert",
  "admin.externalEnabledDesc": "Materialien extern sichtbar machen",
  "admin.approvalRequired": "Genehmigung erforderlich",
  "admin.approvalRequiredDesc": "Manager-Genehmigung für Anfragen erforderlich",
  "admin.strictDocs": "Strenge Dokumentation",
  "admin.strictDocsDesc": "Importe ohne Spezifikationsblätter blockieren",
  "admin.saveSettings": "Einstellungen speichern",
  "admin.scenarioImpact": "Szenario-Auswirkungen",
  "admin.scenarioImpactDesc": "Echtzeit-Auswirkungen der aktuellen Einstellungen",
  "admin.escalatedRequests": "Eskalierte Anfragen",
  "admin.pendingRequests": "Ausstehende Anfragen",
  "admin.internalWindowItems": "Im internen Fenster",
  "admin.docsBlocked": "Doku-blockiert",
  "admin.externalOpen": "Extern offen",
  "admin.externalBlocked": "Extern gesperrt",
  "admin.manualApproval": "Manuelle Genehmigung",
  "admin.autoApproval": "Auto-Genehmigung",
  "admin.strictDocsActive": "Strenge Dokumentation aktiv",
  "admin.settingsSaved": "Einstellungen erfolgreich gespeichert",
  "admin.settingsFailed": "Einstellungen konnten nicht gespeichert werden",
  "admin.seedData": "Beispieldaten laden",
  "admin.categories": "Kategorien",
  "admin.organizations": "Organisationen",
  "admin.orgTitle": "Unternehmensgruppen",
  "admin.orgDesc": "Mandantenorganisationen verwalten",
  "admin.addGroup": "Gruppe hinzufügen",
  "admin.groupName": "Gruppenname",
  "admin.groupNamePlaceholder": "z.B. Acme Verpackungsgruppe",
  "admin.domainsAllowed": "Erlaubte Domains",
  "admin.noGroups": "Keine Gruppen gefunden. Fügen Sie Ihre erste Unternehmensgruppe hinzu.",
  "admin.sites": "Standorte",
  "admin.sitesTitle": "Standorte",
  "admin.sitesDesc": "Lagerhausstandorte verwalten",
  "admin.addSite": "Standort hinzufügen",
  "admin.noSites": "Keine Standorte gefunden. Fügen Sie Ihren ersten Standort hinzu.",
  "admin.noSitesNoGroup": "Erstellen Sie zuerst eine Unternehmensgruppe, bevor Sie Standorte hinzufügen.",
  "admin.externalCompanies": "Externe Firmen",
  "admin.externalCompaniesDesc": "Externe Firmenregistrierungen und Genehmigungen verwalten",
  "admin.addCompany": "Firma hinzufügen",
  "admin.companyName": "Firmenname",
  "admin.companyNamePlaceholder": "z.B. PackPro GmbH",
  "admin.vatId": "USt-IdNr.",
  "admin.contactName": "Kontaktperson",
  "admin.contactEmail": "Kontakt-E-Mail",
  "admin.contactPhone": "Kontakttelefon",
  "admin.industry": "Branche",
  "admin.website": "Webseite",
  "admin.street": "Straße",
  "admin.houseNumber": "Hausnummer",
  "admin.postalCode": "Postleitzahl",
  "admin.city": "Stadt",
  "admin.country": "Land",
  "admin.noCompanies": "Noch keine externen Firmen registriert.",
  "admin.approveCompany": "Genehmigen",
  "admin.rejectCompany": "Ablehnen",
  "admin.companyApproved": "Firma genehmigt",
  "admin.companyRejected": "Firma abgelehnt",
  "admin.companyCreated": "Firma erfolgreich erstellt",
  "admin.companyFailed": "Fehler beim Aktualisieren der Firma",
  "admin.ndaSigned": "NDA unterzeichnet",
  "admin.ndaNotSigned": "NDA ausstehend",
  "admin.auditLog": "Audit-Protokoll",
  "admin.auditLogDesc": "Vollständige Historie aller Systemänderungen",
  "admin.auditEntity": "Entität",
  "admin.auditAction": "Aktion",
  "admin.auditUser": "Benutzer",
  "admin.auditTimestamp": "Zeitstempel",
  "admin.auditChanges": "Änderungen",
  "admin.auditNoEntries": "Keine Audit-Einträge gefunden.",
  "admin.auditFilterEntity": "Nach Entität filtern",
  "admin.auditFilterAction": "Nach Aktion filtern",
  "admin.auditAll": "Alle",
  "admin.auditPrevPage": "Zurück",
  "admin.auditNextPage": "Weiter",
  "admin.auditPage": "Seite {{page}} von {{pages}}",
  "admin.guide": "Anleitung",
  "admin.guideTitle": "Administrationshandbuch",
  "admin.guideVotes.title": "Am schlechtesten bewertete Handbuch-Abschnitte",
  "admin.guideVotes.desc": "Die 5 Abschnitte mit der negativsten Nutzerbewertung – hier lohnt sich eine Überarbeitung.",
  "admin.guideVotes.empty": "Noch keine Bewertungen vorhanden.",
  "admin.guideVotes.loading": "Bewertungen werden geladen…",
  "admin.guideVotes.unknownSection": "Unbekannter Abschnitt",
  "admin.guideVotes.score": "Netto-Bewertung (Daumen hoch − runter)",
  "admin.guideDesc": "Umfassende Anleitung für Plattform-Setup, Governance und tägliche Verwaltung",
  "admin.platformAdminDesc": "Plattformverwaltung - alle Gruppen, Standorte und Nutzer verwalten",
  "admin.groupAdminDesc": "Strategie und Nutzer für Ihre Firmengruppe verwalten",
  "admin.groupAdmin": "Gruppenadmin",
  "admin.selectGroup": "Firmengruppe auswählen",
  "admin.selectGroupPlaceholder": "Gruppe auswählen...",
  "admin.loadSettings": "Einstellungen laden",
  "admin.groupUsersDesc": "Nutzer innerhalb Ihrer Firmengruppe verwalten und genehmigen",
  "admin.guideGettingStarted": "Erste Schritte",
  "admin.guideGettingStartedText": "Willkommen bei Surplify! Diese Plattform hilft Ihrer Organisation, Betriebskapital zu reduzieren, indem langsam drehende und nicht drehende Rohstoffe standortübergreifend umverteilt werden. Nach der Ersteinrichtung können Ihre Teams überschüssige Materialien einstellen, benötigte Artikel suchen und Bestand zwischen Standorten oder externen Partnern transferieren.",
  "admin.guideGettingStartedSteps": ["Erstellen Sie Ihre Firmengruppe und mindestens einen Standort unter Admin > Organisationen und Standorte.", "Initiale Daten laden mit dem Button 'Daten laden' (nur einmalig für Demo/Test).", "Laden Sie Nutzer ein, indem Sie den Registrierungslink teilen. Genehmigen Sie neue Nutzer unter Admin > Benutzer.", "Konfigurieren Sie Ihren bevorzugten Governance-Modus unter Admin > Szenarien.", "Laden Sie Materialien über die Import-Seite hoch oder erstellen Sie diese einzeln."],
  "admin.guideGettingStartedTip": "Verwenden Sie den 'Daten laden'-Button, um Kategorien, Beispielmaterialien und Übersetzungen für eine schnelle Demo zu laden.",
  "admin.guideScenarios": "Szenario-Konfiguration",
  "admin.guideScenariosText": "Szenarien steuern die Governance-Regeln für die Materialumverteilung. Jeder Modus passt Sichtbarkeitsfenster, Eskalationsschwellen, externen Zugang und Genehmigungsanforderungen an.",
  "admin.guideScenariosSteps": ["Wählen Sie einen Szenario-Modus: Ausgewogen (Standard), Konservativ, Aggressiv (Cash) oder Krisenmodus.", "Passen Sie das 'Interne Fenster' an (Tage, die Materialien ausschließlich intern sichtbar bleiben).", "Setzen Sie 'Eskalationstage' für automatische Benachrichtigungen bei alternden Anfragen.", "Schalten Sie 'Extern aktiviert' ein/aus, um den Zugang externer Firmen zu steuern.", "Schalten Sie 'Genehmigung erforderlich' für Auto-Genehmigung oder manuelle Prüfung von Anfragen.", "Aktivieren Sie 'Strenge Dokumentation', um Anfragen für Artikel ohne Spezifikationsblatt zu blockieren."],
  "admin.guideScenariosTip": "Das Szenario-Auswirkungen-Dashboard zeigt Echtzeit-Effekte Ihrer aktuellen Einstellungen, einschließlich eskalierter Anfragen und blockierter Artikel.",
  "admin.guideUsers": "Benutzerverwaltung",
  "admin.guideUsersText": "Benutzer registrieren sich über die Plattform und müssen genehmigt werden, bevor sie sensible Daten wie Preise, Mengen und Standorte einsehen können. Admins können Genehmigungen verwalten und den Zugang jederzeit widerrufen.",
  "admin.guideUsersSteps": ["Navigieren Sie zu Admin > Benutzer, um alle registrierten Nutzer zu sehen.", "Ausstehende Nutzer sind mit einem gelben Indikator markiert.", "Klicken Sie auf 'Genehmigen', um vollen Marktplatz-Zugang zu gewähren.", "Klicken Sie auf 'Widerrufen', um den Zugang eines Nutzers vorübergehend zu deaktivieren.", "Admin-Benutzer werden bei der Registrierung automatisch genehmigt."],
  "admin.guideUsersTip": "Das Widerrufen eines Nutzers löscht nicht das Konto. Der Nutzer kann jederzeit erneut genehmigt werden.",
  "admin.guideCategories": "Kategorienverwaltung",
  "admin.guideCategoriesText": "Kategorien organisieren Materialien in einer hierarchischen Baumstruktur. Sie steuern die Seitenleisten-Navigation auf dem Marktplatz und helfen Nutzern, Materialien nach Typ zu durchsuchen.",
  "admin.guideCategoriesSteps": ["Navigieren Sie zu Admin > Kategorien, um den Kategorienbaum anzuzeigen.", "Klicken Sie auf 'Kategorie hinzufügen' für eine Hauptkategorie.", "Klicken Sie auf das '+'-Symbol einer Kategorie, um eine Unterkategorie hinzuzufügen.", "Bearbeiten oder löschen Sie bestehende Kategorien über die Aktionsbuttons.", "Kategorien können über das Sortierfeld neu angeordnet werden."],
  "admin.guideCategoriesTip": "Gelöschte Kategorien werden soft-gelöscht (deaktiviert). Zuvor zugeordnete Materialien bleiben zugänglich.",
  "admin.guideExternal": "Externe Firmen",
  "admin.guideExternalText": "Externe Firmen können sich selbst auf der Plattform registrieren. Plattform-Admins prüfen Anträge und genehmigen oder lehnen sie ab. Bei Genehmigung werden automatisch eine Firmengruppe und ein Standort erstellt, und die externen Nutzer erhalten Marktplatz-Zugang.",
  "admin.guideExternalSteps": ["Externe Firmen registrieren sich über das öffentliche Formular (/register-external).", "Navigieren Sie zu Admin > Externe Firmen, um ausstehende Anträge zu prüfen.", "Klicken Sie auf 'Genehmigen', um die Firma zu aktivieren. Dies erstellt automatisch den Mandanten (Gruppe + Standort).", "Klicken Sie auf 'Ablehnen', um den Zugang zu verweigern. Die Firma wird per E-Mail benachrichtigt.", "Genehmigte Firmen können eigene Materialien auf dem Marktplatz einstellen.", "Klicken Sie auf eine Firmenzeile, um verknüpfte Benutzer anzuzeigen."],
  "admin.guideExternalTip": "Bei Genehmigung oder Ablehnung wird automatisch eine E-Mail-Benachrichtigung an den Firmenkontakt und verknüpfte Benutzer gesendet.",
  "admin.guideImport": "Excel Import/Export",
  "admin.guideImportText": "Die Import-Seite unterstützt Massen-Materialverwaltung durch Excel-Datei-Upload. Sie können eine Vorlage herunterladen, Ihre Daten eingeben, validieren und dann den Import ausführen.",
  "admin.guideImportSteps": ["Navigieren Sie zur Import-Seite über die Navigationsleiste.", "Laden Sie die Excel-Vorlage herunter, um das erwartete Spaltenformat zu sehen.", "Füllen Sie Ihre Materialdaten aus und laden Sie die Datei hoch.", "Prüfen Sie die Validierungsergebnisse. Fehler werden pro Zeile hervorgehoben.", "Wählen Sie einen Import-Modus: Alles überschreiben, Nur ergänzen oder Felder auswählen.", "Führen Sie den Import aus, um Materialien und SKUs zu erstellen oder zu aktualisieren."],
  "admin.guideImportTip": "Verwenden Sie den Modus 'Nur ergänzen' für inkrementelle Updates, ohne vorhandene Daten zu überschreiben.",
  "admin.guideDashboard": "Dashboard & Reporting",
  "admin.guideDashboardText": "Das Dashboard bietet Echtzeit-KPIs zu Bestandsalter, Transferaktivität, Nachhaltigkeitsmetriken und gefährdetem Wert. Standortmanager können nach Standort filtern und PDF-Berichte generieren.",
  "admin.guideDashboardSteps": ["Navigieren Sie zum Dashboard über die Navigationsleiste.", "Prüfen Sie globale KPIs: Gesamtmaterialien, umverteilte Menge, CO2-Einsparungen und erhaltener Wert.", "Verwenden Sie den Standortfilter, um standortspezifische Metriken anzuzeigen.", "Laden Sie ESG/Nachhaltigkeits-PDF-Berichte für Management-Präsentationen herunter.", "Überwachen Sie gefährdete Materialien (langsam drehend und nicht drehend)."],
  "admin.guideDashboardTip": "Der Nachhaltigkeitsbericht enthält geschätzte CO2-Einsparungen basierend auf umverteilten Materialmengen.",
  "admin.guideNotifications": "E-Mail-Benachrichtigungen",
  "admin.guideNotificationsText": "Die Plattform sendet automatische E-Mail-Benachrichtigungen für eskalierte Anfragen, neue Materialanfragen und Statusänderungen externer Firmen. Der gesamte Benachrichtigungsverlauf wird protokolliert und ist unter Admin > Benachrichtigungen einsehbar.",
  "admin.guideNotificationsSteps": ["Navigieren Sie zu Admin > Benachrichtigungen, um das Benachrichtigungs-Dashboard anzuzeigen.", "Prüfen Sie Statistiken: Gesamtzahl gesendet, fehlgeschlagen und nach Typ (Neue Anfrage, Eskalation, Externe Firma).", "Klicken Sie auf 'Jetzt prüfen', um die Eskalationsprüfung manuell auszulösen.", "Durchsuchen Sie den Benachrichtigungsverlauf mit Details zu Empfängern und Zustellstatus.", "E-Mail-Benachrichtigungen erfordern einen konfigurierten Resend API-Schlüssel im Backend."],
  "admin.guideNotificationsTip": "Eskalations-E-Mails werden ausgelöst, wenn ausstehende Anfragen den konfigurierten 'Eskalationstage'-Schwellenwert in den Szenario-Einstellungen überschreiten.",
  "admin.guideAudit": "Audit-Protokoll",
  "admin.guideAuditText": "Das Audit-Protokoll bietet eine vollständige Historie aller Systemänderungen für Compliance und Nachvollziehbarkeit. Jede Aktion wird mit Benutzer, Zeitstempel, Entitätstyp und detaillierten Änderungsdaten erfasst.",
  "admin.guideAuditSteps": ["Navigieren Sie zu Admin > Audit-Protokoll, um das Protokoll anzuzeigen.", "Verwenden Sie den Entitätstyp-Filter (Einstellungen, Benutzer, SKU, Material, Anfrage).", "Verwenden Sie den Aktionsfilter (Erstellen, Aktualisieren, Löschen, Genehmigen, Widerrufen).", "Erweitern Sie den 'Änderungen'-Bereich eines Eintrags, um die genauen geänderten Daten zu sehen.", "Verwenden Sie die Seitennavigation, um historische Einträge zu durchblättern."],
  "admin.guideAuditTip": "Das Audit-Protokoll ist unveränderlich und kann nicht bearbeitet oder gelöscht werden. Nutzen Sie es für Compliance-Audits und Fehlerbehebung.",
  "admin.notifTypeExtCompany": "Ext. Firmen",
  "admin.notifExtApproved": "Genehmigt",
  "admin.notifExtRejected": "Abgelehnt",
  "admin.notifExtCompany": "Externe Firma",
  "admin.mode.balanced": "Ausgewogen",
  "admin.mode.balancedDesc": "Standard-Governance-Regeln",
  "admin.mode.conservative": "Konservativ",
  "admin.mode.conservativeDesc": "Längere Fenster, mehr Genehmigungen",
  "admin.mode.aggressive_cash": "Aggressiv (Cash)",
  "admin.mode.aggressive_cashDesc": "Kürzere Fenster, schnellere Liquidation",
  "admin.mode.crisis_mode": "Krisenmodus",
  "admin.mode.crisis_modeDesc": "Notfall-Entsorgungsmodus",
  "admin.notifications": "Benachrichtigungen",
  "admin.notificationsTitle": "E-Mail-Benachrichtigungen",
  "admin.triggerCheck": "Jetzt pruefen",
  "admin.triggerCheckDesc": "Eskalierte Anfragen manuell pruefen und Benachrichtigungen senden",
  "admin.triggerCheckSuccess": "Eskalationspruefung abgeschlossen",
  "admin.triggerCheckFailed": "Eskalationspruefung fehlgeschlagen",
  "admin.emailsSent": "E-Mails gesendet",
  "admin.emailsFailed": "E-Mails fehlgeschlagen",
  "admin.lastCheck": "Letzte Pruefung",
  "admin.noNotifications": "Noch keine Benachrichtigungen gesendet",
  "admin.notifMaterial": "Material",
  "admin.notifRequester": "Anfragender",
  "admin.notifOwner": "Verantwortlicher",
  "admin.notifSite": "Standort",
  "admin.notifDaysPending": "Tage ausstehend",
  "admin.notifSentAt": "Gesendet am",
  "admin.notifRecipients": "Empfaenger",
  "admin.notifStatus": "Status",
  "admin.totalNotifications": "Benachrichtigungen gesamt",
  "admin.emailsSkipped": "Uebersprungen",
  "admin.notifTypeNewRequest": "Neue Anfrage",
  "admin.notifTypeEscalation": "Eskalation",
  "admin.notifRequestedQty": "Angefragte Menge",
  "admin.notificationsDesc": "E-Mail-Verlauf (Eskalationen & neue Anfragen)",
  "ext.registerTitle": "Als externes Unternehmen registrieren",
  "ext.registerDesc": "Registrieren Sie Ihr Unternehmen, um Materialien auf dem Marktplatz anzubieten.",
  "ext.companyInfo": "Firmendaten",
  "ext.userAccount": "Benutzerkonto",
  "ext.nextStep": "Weiter zum Benutzerkonto",
  "ext.backStep": "Zurück",
  "ext.submitRegistration": "Registrierung absenden",
  "ext.fillRequired": "Bitte füllen Sie alle Pflichtfelder aus",
  "ext.passwordMismatch": "Passwörter stimmen nicht überein",
  "ext.passwordTooShort": "Passwort muss mindestens 6 Zeichen haben",
  "ext.confirmPassword": "Passwort bestätigen",
  "ext.registrationSuccess": "Registrierung erfolgreich!",
  "ext.registrationPending": "Ihre Firma wird jetzt geprüft. Sie erhalten eine Benachrichtigung, sobald Ihr Zugang freigeschaltet wurde.",
  "ext.alreadyRegistered": "Bereits registriert?",
  "ext.internalUser": "Interner Benutzer?",
  "ext.registerInternal": "Hier registrieren",
  "ext.registerAsExternal": "Als externes Unternehmen registrieren",
  "ext.myCompany": "Mein Unternehmen",
  "ext.portalTitle": "Unternehmensportal",
  "ext.pendingTitle": "Genehmigung ausstehend",
  "ext.pendingMessage": "Ihre Registrierung wird derzeit von unserem Team geprüft. Sobald Ihr Unternehmen genehmigt wurde, können Sie Materialien auf dem Marktplatz anbieten.",
  "ext.rejectedTitle": "Registrierung abgelehnt",
  "ext.rejectedMessage": "Leider wurde Ihre Registrierung abgelehnt. Bitte kontaktieren Sie den Support für weitere Informationen.",
  "ext.myListings": "Meine Angebote",
  "ext.createListing": "Material einstellen",
  "ext.noListings": "Noch keine Materialien eingestellt",
  "ext.noListingsDesc": "Stellen Sie Ihr erstes Material ein, um es auf dem Marktplatz anzubieten.",
  "ext.createFirstListing": "Erstes Material einstellen",
  "ext.noCompanyLinked": "Kein externes Unternehmen verknüpft",
  "ext.linkedUsers": "Verknüpfte Benutzer",
  "ext.noLinkedUsers": "Keine verknüpften Benutzer",
  "ext.registrationType": "Typ",
  "ext.chooseRegistrationType": "Wie möchten Sie sich registrieren?",
  "ext.registerAsGroup": "Als Gruppe",
  "ext.registerAsGroupDesc": "Unternehmen mit mehreren Werken/Standorten",
  "ext.registerAsSite": "Als Einzelwerk",
  "ext.registerAsSiteDesc": "Einzelner Standort ohne übergeordnete Gruppe",
  "ext.registerGroupDesc": "Registrieren Sie Ihre Gruppe, um mit mehreren Standorten am Marktplatz teilzunehmen.",
  "ext.registerSiteDesc": "Registrieren Sie Ihr Werk als einzelnen Standort am Marktplatz.",
  "ext.continue": "Weiter",
  "ext.groupName": "Gruppenname",
  "ext.siteName": "Werkname",
  "ext.materialDeleted": "Material wurde gelöscht",
  "ext.deleteConfirmTitle": "Material löschen?",
  "ext.deleteConfirmDesc": "Sind Sie sicher, dass Sie dieses Material löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden.",
  "common.view": "Ansehen",
  "common.edit": "Bearbeiten",
  "common.delete": "Löschen",
  "common.deleting": "Löschen...",
  "status.available": "Verfügbar",
  "status.documentation_missing": "Dok. fehlt",
  "status.archived": "Archiviert",
  "footer.tagline": "Governance-gesteuerter Marktplatz für überschüssige Verpackungsmaterialien. Betriebskapital durch intelligente Umverteilung reduzieren.",
  "footer.marketplace": "Marktplatz",
  "footer.forPartners": "Für Partner",
  "footer.support": "Support",
  "footer.legalTitle": "Rechtliches",
  "footer.agb": "AGB",
  "footer.impressum": "Impressum",
  "footer.datenschutz": "Datenschutz",
  "footer.datenschutzeinstellungen": "Datenschutzeinstellungen",
  "footer.rights": "Alle Rechte vorbehalten.",
  "admin.legalPages": "Rechtliches",
  "admin.platformSettings": "Einstellungen",
  "admin.resendEmail": "E-Mail erneut senden",
  "admin.legalPagesDesc": "Support, AGB, Impressum, Datenschutz und Datenschutzeinstellungen bearbeiten",
  "admin.legalPageTitle": "Seitentitel",
  "admin.legalPageContent": "Seiteninhalt (HTML)",
  "admin.legalPreview": "Vorschau",
  "nav.myGroup": "Meine Gruppe",
  "nav.scenario": "Szenario",
  "nav.groupRequests": "Werksanfragen",
  "groupRequests.title": "Eingehende Werksanfragen",
  "groupRequests.subtitle": "Anfragen an die Werke Ihrer Gruppe",
  "groupRequests.pending": "offen",
  "groupRequests.filterAll": "Alle Status",
  "groupRequests.empty": "Keine eingehenden Werksanfragen",
  "groupRequests.emptyHint": "Aktuell gibt es keine Anfragen an Ihre Werke.",
  "groupRequests.site": "Zielwerk",
  "dashboard.categoryBreakdown": "Kategorie-Aufschlüsselung",
  "dashboard.categoryBreakdownDesc": "Top-Kategorien nach Risikowert",
  "dashboard.topRisk": "Top-Risiko-Materialien",
  "dashboard.topRiskDesc": "Materialien mit dem höchsten Wert (langsam/nicht drehend)",
  "dashboard.valueAtRisk": "Gefährdeter Wert",
  "dashboard.valueAtRiskDesc": "Buchwert der langsam/nicht drehenden Bestände",
  "dashboard.totalValue": "Gesamtbestandswert",
  "dashboard.totalValueDesc": "Gesamtbuchwert aller aktiven SKUs",
  "dashboard.agingAutoCalculated": "Alterung wird automatisch aus dem Produktionsdatum berechnet",
  "dashboard.kEUR": "kEUR",
  "dashboard.items": "Artikel",
  "dashboard.skus": "SKUs",
  "group.title": "Materialien meiner Gruppe",
  "group.subtitle": "Alle Materialien über alle Standorte Ihrer Unternehmensgruppe",
  "group.allSites": "Alle Standorte",
  "group.filterSite": "Nach Standort filtern",
  "group.filterStatus": "Nach Status filtern",
  "group.noMaterials": "Keine Materialien in Ihrer Gruppe gefunden",
  "group.ownMaterial": "Eigenes Material",
  "group.otherSite": "Anderer Standort",
  "group.skuCount": "{{count}} SKUs",
  "group.totalValue": "Gesamtwert",
  "group.sites": "Standorte",
  "scenario.title": "Szenario Was-Wäre-Wenn-Analyse",
  "scenario.subtitle": "Vorschau der Auswirkungen von Governance-Änderungen vor dem Anwenden",
  "scenario.currentSettings": "Aktuelle Einstellungen",
  "scenario.whatIf": "Was-Wäre-Wenn Vorschau",
  "scenario.applyChanges": "Änderungen anwenden",
  "scenario.preview": "Auswirkungen vorschauen",
  "scenario.previewResult": "Prognostizierte Auswirkungen",
  "scenario.escalatedRequests": "Eskalierte Anfragen",
  "scenario.pendingRequests": "Ausstehende Anfragen",
  "scenario.docsBlocked": "Doku-blockiert",
  "scenario.internalWindow": "Im internen Fenster",
  "scenario.externalAccess": "Externer Zugang",
  "scenario.autoApproved": "Auto-genehmigt",
  "scenario.valueAtRisk": "Gefährdeter Wert",
  "scenario.itemsAtRisk": "Gefährdete Artikel",
  "scenario.noChanges": "Passen Sie die Einstellungen an und klicken Sie auf 'Vorschau', um die Auswirkungen zu sehen",
  "scenario.enabled": "Aktiviert",
  "scenario.blocked": "Gesperrt",
  "nav.standardMaterials": "Standard-Materialien",
  "nav.transactions": "Transaktionen",
  "nav.matching": "Material-Matching",
  "nav.analytics": "Analytics",
  "nav.language": "Sprache",
  "nav.switchGroup": "Gruppe wechseln",
  "matching.title": "Material-Matching",
  "matching.subtitle": "Automatisches Matching von Überschüssen mit dem Bedarf anderer Standorte",
  "matching.refresh": "Aktualisieren",
  "matching.matches": "Matches",
  "matching.matchRate": "Matching-Rate",
  "matching.potSavings": "Pot. Einsparung",
  "matching.sites": "Standorte",
  "matching.surplusAvailable": "{{count}} Überschüsse verfügbar",
  "matching.demandPositions": "{{count}} Bedarfspositionen",
  "matching.matchedQuantity": "{{count}} kg gematchte Menge",
  "matching.providers": "{{count}} Anbieter",
  "matching.consumers": "{{count}} Nachfrager",
  "matching.topMaterials": "Top-Materialien mit Matches",
  "matching.offerSite": "Anbieter-Standort",
  "matching.demandSite": "Bedarfs-Standort",
  "matching.manufacturer": "Hersteller",
  "matching.searchManufacturer": "Hersteller suchen...",
  "matching.allSites": "Alle Standorte",
  "matching.noMatches": "Keine Matches gefunden",
  "matching.noMatchesDesc": "Es wurden keine Übereinstimmungen zwischen Überschüssen und Bedarfslisten gefunden.",
  "matching.matchesFound": "{{count}} Match(es) gefunden",
  "matching.material": "Material",
  "matching.provider": "Anbieter",
  "matching.consumer": "Nachfrager",
  "matching.quantity": "Menge",
  "matching.bookValue": "Buchwert",
  "matching.age": "Alter",
  "matching.width": "Breite",
  "matching.widthFit": "Passt",
  "matching.widthDeviation": "Abw.",
  "matching.action": "Aktion",
  "matching.view": "Ansehen",
  "matching.age0_90": "0–90 Tage",
  "matching.age91_180": "91–180 Tage",
  "matching.age181_360": "181–360 Tage",
  "matching.ageGt360": "> 360 Tage",
  "analytics.title": "Analytics & Reporting",
  "analytics.subtitle": "Trendanalysen, Standort-Performance und Matching-Auswertungen",
  "analytics.tabTrends": "Trends",
  "analytics.tabSites": "Standorte",
  "analytics.tabMatching": "Matching",
  "analytics.last6Months": "Letzte 6 Monate",
  "analytics.last12Months": "Letzte 12 Monate",
  "analytics.last24Months": "Letzte 24 Monate",
  "analytics.inventoryTrend": "Bestandsentwicklung",
  "analytics.inventoryTrendDesc": "Monatliche Entwicklung von Artikelanzahl und Bestandswert",
  "analytics.articles": "Artikel",
  "analytics.valueKEUR": "Wert (kEUR)",
  "analytics.transactionVolume": "Transaktionsvolumen",
  "analytics.transactionVolumeDesc": "Monatliche Transaktionen",
  "analytics.transactions": "Transaktionen",
  "analytics.requestTrend": "Anfragen-Entwicklung",
  "analytics.requestTrendDesc": "Gesamt vs. abgeschlossene Anfragen",
  "analytics.requests": "Anfragen",
  "analytics.completed": "Abgeschlossen",
  "analytics.siteComparison": "Standort-Vergleich: Bestandswert",
  "analytics.siteComparisonDesc": "Gesamtwert (kEUR) nach Standort",
  "analytics.redistributionRanking": "Umverteilungs-Ranking",
  "analytics.redistributionRankingDesc": "Abgeschlossene Umverteilungen pro Standort",
  "analytics.redistributions": "Umverteilungen",
  "analytics.openRequests": "Offene Anfragen",
  "analytics.siteDetails": "Standort-Details",
  "analytics.site": "Standort",
  "analytics.value": "Wert (kEUR)",
  "analytics.slowMoving": "Slow-Moving",
  "analytics.redistributed": "Umverteilt",
  "analytics.demand": "Bedarf",
  "analytics.noSiteData": "Keine Standortdaten verfügbar",
  "analytics.kpiMatches": "Matches",
  "analytics.kpiMatchRate": "Matching-Rate",
  "analytics.kpiMatchedValue": "Matched Wert",
  "analytics.kpiMaterials": "Materialien",
  "analytics.topMatchedMaterials": "Top gematchte Materialien",
  "analytics.categoryDistribution": "Matches nach Kategorie",
  "analytics.sitePairFlows": "Standort-Flüsse (Anbieter → Nachfrager)",
  "analytics.sitePairFlowsDesc": "Häufigste Material-Flüsse zwischen Standorten",
  "analytics.noData": "Keine Daten",
  "analytics.noMatchingData": "Keine Matching-Daten verfügbar",
  "transactions.title": "Transaktionen",
  "transactions.subtitle": "Alle abgeschlossenen und offenen Transaktionen",
  "transactions.allStatuses": "Alle Status",
  "transactions.statusCompleted": "Abgeschlossen",
  "transactions.statusCancelled": "Storniert",
  "transactions.statusPending": "Offen",
  "transactions.total": "Transaktionen",
  "transactions.completed": "Abgeschlossen",
  "transactions.totalValue": "Gesamtwert",
  "transactions.date": "Datum",
  "transactions.material": "Material",
  "transactions.type": "Typ",
  "transactions.seller": "Verkäufer",
  "transactions.buyer": "Käufer",
  "transactions.quantity": "Menge",
  "transactions.value": "Wert",
  "transactions.fee": "Gebühr",
  "transactions.status": "Status",
  "transactions.rating": "Bewertung",
  "transactions.internal": "Intern",
  "transactions.external": "Extern",
  "transactions.empty": "Noch keine Transaktionen vorhanden",
  "transactions.emptyDesc": "Transaktionen werden automatisch bei abgeschlossenen Anfragen erstellt.",
  "transactions.rate": "Bewerten",
  "transactions.rated": "Bewertet",
  "transactions.rateTitle": "Transaktion bewerten",
  "transactions.counterparty": "Gegenpartei",
  "transactions.unknown": "Unbekannt",
  "transactions.commentLabel": "Kommentar (optional)",
  "transactions.commentPlaceholder": "Wie war die Zusammenarbeit?",
  "transactions.submitRating": "Bewertung abgeben",
  "transactions.submitting": "Wird gesendet...",
  "transactions.ratingSuccess": "Bewertung abgegeben",
  "transactions.ratingError": "Fehler beim Bewerten",
  "transactions.ratingRequired": "Bitte mindestens eine Kategorie bewerten",
  "transactions.loadError": "Fehler beim Laden der Transaktionen",
  "transactions.reviews": "Bewertungen",
  "transactions.noReviews": "Noch keine Bewertungen vorhanden.",
  "transactions.comments": "Kommentare",
  "transactions.group": "Gruppe",
  "transactions.review": "Bewertungen",
  "notifications.title": "Benachrichtigungen",
  "notifications.allRead": "Alle gelesen",
  "notifications.none": "Keine Benachrichtigungen",
  "notifications.noFiltered": "Keine passenden Benachrichtigungen",
  "notifications.filterAll": "Alle",
  "notifications.filterMatches": "Matches",
  "notifications.filterOther": "Sonstige",
  "notifications.newMatch": "{{count}} neuer Material-Match",
  "notifications.newMatches": "{{count}} neue Material-Matches",
  "notifications.goToDashboard": "Zum Dashboard",
  "notifications.matchDashboard": "Material-Matching Dashboard anzeigen",
  "notifications.justNow": "gerade eben",
  "notifications.minutesAgo": "vor {{count}} Min.",
  "notifications.hoursAgo": "vor {{count}} Std.",
  "notifications.daysAgo": "vor {{count}} T.",
  "notifications.site": "Standort",
  "notifications.typeMatch": "Match",
  "notifications.typeApproval": "Freigabe-Match",
  "notifications.typeRequest": "Anfrage",
  "notifications.typeEscalation": "Eskalation",
  "notifications.typeLogistics": "Logistik",
  "notifications.typeInfo": "Info",
  "partners.heroTitle": "Kaufen. Verkaufen. Wiederverwenden. Überschussmaterialien — smarter.",
  "partners.heroSubtitle": "Werden Sie Teil des führenden Marktplatzes für Verpackungsüberschüsse. Geprüfte Materialien von Top-Herstellern – mit bis zu 40% Kostenersparnis.",
  "partners.ctaRegister": "Als Partner registrieren",
  "partners.ctaBrowse": "Materialien durchsuchen",
  "partners.trust1": "Kostenlose Registrierung",
  "partners.trust2": "Geprüfte Lieferanten",
  "partners.trust3": "Keine Bindung",
  "partners.howItWorksLabel": "Ablauf",
  "partners.howItWorksTitle": "So funktioniert es",
  "partners.howItWorksSubtitle": "Drei einfache Schritte zu mehr Ersparnis bei der Materialbeschaffung.",
  "partners.step1Title": "Registrieren",
  "partners.step1Desc": "Erstellen Sie Ihr Unternehmenskonto in wenigen Minuten. Unser Team prüft und aktiviert Ihren Zugang.",
  "partners.step2Title": "Durchsuchen",
  "partners.step2Desc": "Durchsuchen Sie tausende geprüfter Überschussmaterialien von Verpackungsherstellern. Filtern nach Typ, Menge und Standort.",
  "partners.step3Title": "Anfragen",
  "partners.step3Desc": "Senden Sie eine Anfrage direkt an den Lieferanten. Die Plattform verwaltet den gesamten Prozess von der Verhandlung bis zur Lieferung.",
  "partners.benefitsTitle": "Warum Surplify als Partner wählen",
  "partners.benefit1Title": "Bis zu 40% sparen",
  "partners.benefit1Desc": "Zugang zu Überschussmaterialien zu einem Bruchteil des Originalpreises. Echte Ersparnis bei PE-Folien, Etiketten und mehr.",
  "partners.benefit2Title": "Geprüfte Qualität",
  "partners.benefit2Desc": "Jedes Angebot enthält Herstellerdaten, Spezifikationen und Zustandsberichte. Kaufen Sie mit Vertrauen.",
  "partners.benefit3Title": "ESG-Wirkung",
  "partners.benefit3Desc": "Jeder Kauf reduziert CO2-Emissionen und verhindert Abfall. Vollständige Rückverfolgbarkeit für Ihren Nachhaltigkeitsbericht.",
  "partners.trustTitle": "Von Branchenführern vertraut",
  "partners.trustSubtitle": "Unternehmen quer durch Europa setzen auf Surplify",
  "partners.trustUsers": "50+ Unternehmen",
  "partners.trustStat1": "40%",
  "partners.trustStat1Label": "Durchschnittliche Kostenersparnis",
  "partners.trustStat2": "500+",
  "partners.trustStat2Label": "Geprüfte Materialangebote",
  "partners.trustStat3": "50+",
  "partners.trustStat3Label": "Aktive Partner-Unternehmen",
  "partners.ctaFinalTitle": "Bereit zu sparen?",
  "partners.ctaFinalDesc": "Schließen Sie sich hunderten Unternehmen an, die Surplify nutzen, um Beschaffungskosten zu senken und ESG-Ziele zu erreichen.",
  "partners.ctaFinalRegister": "Jetzt kostenlos starten",
  "partners.noCredit": "Keine Kreditkarte erforderlich. Kostenlose Registrierung.",
  "demo.badge": "Demo buchen",
  "demo.ctaHero": "Demo buchen",
  "demo.title": "Surplify live erleben",
  "demo.subtitle": "Buchen Sie eine kostenlose, persönliche Demo mit unserem Team. Wir zeigen Ihnen, wie Surplify Ihre Materialbeschaffung optimiert und Kosten senkt.",
  "demo.point1": "Live-Rundgang durch die Plattform",
  "demo.point2": "Auf Ihre Branche & Bedürfnisse zugeschnitten",
  "demo.point3": "Unverbindlich — komplett kostenlos",
  "demo.name": "Name",
  "demo.namePlaceholder": "Ihr vollständiger Name",
  "demo.email": "Geschäftliche E-Mail",
  "demo.emailPlaceholder": "name@firma.de",
  "demo.company": "Unternehmen",
  "demo.companyPlaceholder": "Ihr Firmenname",
  "demo.phone": "Telefon (optional)",
  "demo.phonePlaceholder": "+49 ...",
  "demo.message": "Nachricht (optional)",
  "demo.messagePlaceholder": "Erzählen Sie uns von Ihren Anforderungen...",
  "demo.submit": "Demo anfragen",
  "demo.sending": "Wird gesendet...",
  "demo.privacy": "Wir respektieren Ihre Privatsphäre. Ihre Daten werden nur für die Kontaktaufnahme bezüglich Ihrer Demo-Anfrage verwendet.",
  "demo.requiredFields": "Bitte füllen Sie alle Pflichtfelder aus.",
  "demo.successToast": "Demo-Anfrage erfolgreich gesendet!",
  "demo.errorToast": "Demo-Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
  "demo.successTitle": "Vielen Dank!",
  "demo.successDesc": "Ihre Demo-Anfrage ist eingegangen. Unser Team meldet sich innerhalb von 24 Stunden bei Ihnen, um Ihre persönliche Demo zu vereinbaren.",
  "onboarding.step": "Schritt",
  "onboarding.of": "von",
  "onboarding.skip": "Jetzt überspringen",
  "onboarding.next": "Weiter",
  "onboarding.finish": "Loslegen",
  "onboarding.restartTour": "Tour erneut starten",
  "onboarding.step1Title": "Willkommen bei Surplify",
  "onboarding.step1Desc": "Surplify ist der führende Marktplatz für Verpackungsüberschüsse. Finden, anfragen und handeln Sie geprüfte Überschussmaterialien.",
  "onboarding.step1Points": ["Tausende geprüfte Materialien durchsuchen", "Bis zu 40% gegenüber Neuanschaffungen sparen", "ESG-Wirkung automatisch verfolgen"],
  "onboarding.step2Title": "Ihr Unternehmensprofil",
  "onboarding.step2Desc": "Ihr Profil repräsentiert Ihr Unternehmen auf der Plattform. Ein vollständiges Profil erhöht das Vertrauen anderer Nutzer.",
  "onboarding.step2Points": ["Unternehmenslogo und -beschreibung hinzufügen", "Kontaktdaten verifizieren", "Materialpräferenzen festlegen"],
  "onboarding.step3Title": "Materialien finden",
  "onboarding.step3Desc": "Nutzen Sie die leistungsstarke Suche, um genau das zu finden, was Sie benötigen. Filtern nach Materialtyp, Abmessungen, Menge und Standort.",
  "onboarding.step3Points": ["Suche nach Hersteller oder Artikelnummer", "Filter nach Kategorie, Land und Menge", "Materialien auf die Merkliste setzen"],
  "onboarding.step4Title": "Materialien anfragen",
  "onboarding.step4Desc": "Haben Sie das Passende gefunden? Senden Sie eine Anfrage direkt an den Lieferanten. Die Plattform verwaltet den gesamten Prozess.",
  "onboarding.step4Points": ["Benötigte Menge angeben", "Nachricht an den Lieferanten hinzufügen", "Anfragestatus in Echtzeit verfolgen"],
  "app.subtitle": "Surplus sinnvoll nutzen",
  "auth.loginError": "Ungültige E-Mail oder Passwort",
  "auth.loginSuccess": "Erfolgreich angemeldet!",
  "auth.passwordTooShort": "Passwort muss mindestens 6 Zeichen lang sein",
  "auth.passwordsNoMatch": "Passwörter stimmen nicht überein",
  "auth.registerError": "Registrierung fehlgeschlagen",
  "filter.allCategories": "Alle Kategorien",
  "home.loginRequired": "Bitte anmelden, um die Merkliste zu nutzen",
  "home.materialsCount": "Materialien",
  "home.noMaterials": "Keine Materialien gefunden.",
  "home.seedDescription": "Sie können Beispieldaten laden, um zu starten.",
  "home.seedError": "Fehler beim Laden der Daten",
  "home.seedSuccess": "Daten erfolgreich geladen! Aktualisierung...",
  "home.seeding": "Laden...",
  "home.watchlistError": "Fehler beim Aktualisieren der Merkliste",
  "home.hero.badge": "Circular B2B · Druck & Verpackung",
  "home.hero.verified": "EU-verifiziert",
  "home.hero.headlineA": "Weiternutzen.",
  "home.hero.headlineB": "Reparieren.",
  "home.hero.headlineC": "Umverteilen.",
  "home.hero.subtitle": "Surplify ist der zirkuläre B2B-Marktplatz für die Druck- und Verpackungsindustrie — und gibt Reststoffen, Ersatzteilen und gebrauchten Maschinen ein zweites Leben. Jede Transaktion vermeidet Neuproduktion, spart CO₂ und erhält Working Capital.",
  "home.hero.impactPrefix": "Bereits gemeinsam eingespart:",
  "home.hero.impactSuffix": "CO₂",
  "home.hero.searchPlaceholder": "Hersteller, Teilenummer, Material, Modell…",
  "home.hero.searchBtn": "Suchen",
  "home.hero.verticalMaterials": "Reststoffe",
  "home.hero.verticalSpareParts": "Ersatzteile",
  "home.hero.verticalMachines": "Druckmaschinen",
  "home.hero.verticalPaints": "Farben & Lacke",
  "home.hero.ctaPostWanted": "Gesuch einstellen",
  "home.hero.ctaForSellers": "Für Verkäufer",
  "home.hero.ctaGuide": "Hilfe & Handbuch",
  "home.hero.trustVies": "EU VIES VAT-verifiziert",
  "home.hero.trustCompanies": "Verifizierte Firmenaccounts",
  "home.hero.trustCircular": "Kreislaufwirtschaft",
  "home.newco.badge": "Neu bei Surplify?",
  "home.newco.title": "Ihr Unternehmen in 3 Schritten auf dem B2B-Marktplatz",
  "home.newco.subtitle": "Restmaterial, Reststoffe, Lacke, Ersatzteile und gebrauchte Druckmaschinen — alles auf einer Plattform. Kostenlos starten, fair handeln, REACH/CLP-konform dokumentieren.",
  "home.newco.step1Title": "Unternehmen anlegen",
  "home.newco.step1Desc": "Firmenname, USt-ID, Adresse — VIES-validiert",
  "home.newco.step2Title": "Erstes Inserat erstellen",
  "home.newco.step2Desc": "Material, Lack, Ersatzteil oder Maschine — Formular ausfüllen, fertig",
  "home.newco.step3Title": "Anfragen erhalten & verkaufen",
  "home.newco.step3Desc": "Provision nur bei erfolgreicher Transaktion. Keine Setup-Gebühren.",
  "home.newco.ctaRegister": "Unternehmen jetzt registrieren",
  "home.newco.ctaPartners": "Für Partner & Großkunden",
  "home.newco.disclaimer": "Kostenloser Start-Tarif · Keine Kreditkarte erforderlich · DSGVO & B2B-konform",
  "home.newco.whatYouGet": "Was Sie bekommen",
  "home.newco.freeTier": "Im kostenlosen Start-Tarif",
  "home.newco.feat1Label": "4 Material-Verticals",
  "home.newco.feat1Sub": "Materialien · Lacke · Ersatzteile · Maschinen",
  "home.newco.feat2Label": "Unbegrenzte Inserate",
  "home.newco.feat2Sub": "Auf Standard-Tarif gibt es keine Mengenlimits",
  "home.newco.feat3Label": "Match-Algorithmus",
  "home.newco.feat3Sub": "Käufer-Gesuche werden automatisch zugeordnet",
  "home.newco.feat4Label": "REACH/CLP-Compliance",
  "home.newco.feat4Sub": "Sicherheitsdatenblätter & GHS-Piktogramme integriert",
  "home.newco.feat5Label": "Sustainability-Reporting",
  "home.newco.feat5Sub": "CO₂-Einsparung wird automatisch dokumentiert",
  "home.newco.freeBadge": "100% kostenlos starten",
  "home.pillar.materials.label": "Reststoffe",
  "home.pillar.materials.title": "Reststoffe & Materialien",
  "home.pillar.materials.desc": "Folien, Papier, Rollen, Halbfabrikate — im Kreislauf halten statt verbrennen.",
  "home.pillar.materials.metric": "aktive Inserate",
  "home.pillar.spareParts.label": "Ersatzteile",
  "home.pillar.spareParts.title": "Ersatzteile & Module",
  "home.pillar.spareParts.desc": "OEM-Teile weiternutzen — jedes gerettete Teil vermeidet Neuproduktion und CO₂.",
  "home.pillar.spareParts.metric": "neu",
  "home.pillar.machines.label": "Maschinen",
  "home.pillar.machines.title": "Druckmaschinen",
  "home.pillar.machines.desc": "Gebrauchte Pressen statt Neuanschaffung — bis zu 80 % weniger CO₂ als Neuproduktion.",
  "home.pillar.machines.metric": "verfügbar",
  "home.pillar.paints.label": "Farben & Lacke",
  "home.pillar.paints.title": "Farben, Lacke & Additive",
  "home.pillar.paints.desc": "Restbestände an Druckfarben, Lacken und Additiven — zurück in die Produktion statt teure Sondermüllentsorgung.",
  "home.pillar.paints.metric": "auf Lager",
  "home.sustain.liveImpact": "Live Impact",
  "home.sustain.co2": "CO₂ gespart",
  "home.sustain.redistributed": "umverteilt",
  "home.sustain.sites": "Standorte",
  "home.sustain.circular": "Kreislaufquote",
  "home.sustain.atRisk": "At-Risk",
  "home.machines.label": "Vertical · Maschinen",
  "home.machines.title": "Gebrauchte Druckmaschinen mit zweitem Leben.",
  "home.machines.subtitle": "Jede weiterverkaufte Presse ersetzt eine neu produzierte — mit einem Bruchteil der Ressourcen und CO₂-Emissionen. Inspektion optional, Kompatibilität verifiziert.",
  "home.machines.seeAll": "Alle Maschinen",
  "home.machines.emptyDesc": "Aktuell keine Druckmaschinen verfügbar.",
  "home.machines.emptyCreate": "Inserat erstellen",
  "home.spareParts.label": "Vertical · Ersatzteile",
  "home.spareParts.title": "OEM-Ersatzteile im Kreislauf halten.",
  "home.spareParts.subtitle": "Ungenutzte Bestände, Obsoleszenz-Puffer, stillgelegte Linien — wir bringen Teile zurück in Produktion statt in den Schrott.",
  "home.spareParts.seeAll": "Alle Ersatzteile",
  "home.spareParts.emptyDesc": "Noch keine Ersatzteile gelistet.",
  "home.spareParts.emptyCreate": "Erstes Inserat einstellen",
  "home.paints.label": "Vertical · Farben & Lacke",
  "home.paints.title": "Restbestände an Druckfarben, Lacken und Additiven – zurück in die Maschine.",
  "home.paints.subtitle": "Auslaufende Farbtöne, Restchargen, eingestellte Bestände. Wir bringen Druckchemikalien zurück in die Produktion – statt Sondermüllgebühren zu zahlen.",
  "home.paints.seeAll": "Alle Farben & Lacke",
  "home.paints.emptyDesc": "Aktuell keine Farben, Lacke oder Additive gelistet.",
  "home.paints.emptyCreate": "Erstes Inserat einstellen",
  "home.materials.label": "Vertical · Reststoffe",
  "home.materials.title": "Reststoffe & Produktionsüberbestand.",
  "home.materials.subtitle": "Live-Bestände aus Produktion, Lagerräumung und Qualitätsrückführung — direkt zurück in den Kreislauf.",
  "home.trust.vies.title": "EU VIES VAT",
  "home.trust.vies.desc": "Automatische Verifikation der USt-IdNr. jedes registrierten Unternehmens.",
  "home.trust.companies.title": "Verifizierte Firmen",
  "home.trust.companies.desc": "Nur geprüfte B2B-Accounts erhalten vollen Marktplatz-Zugang.",
  "home.trust.csv.title": "CSV-Massenimport",
  "home.trust.csv.desc": "Tausende Ersatzteile und Materialien in einem einzigen Upload listen.",
  "home.trust.circular.title": "Kreislaufwirtschaft",
  "home.trust.circular.desc": "Jede Umverteilung vermeidet Neuproduktion und reduziert Scope-3-Emissionen.",
  "machine.card.label": "Druckmaschine",
  "machine.card.year": "Baujahr",
  "machine.card.hours": "Std.",
  "machine.card.width": "Breite",
  "machine.card.price": "Preis",
  "sparePart.card.label": "Ersatzteil",
  "sparePart.card.compatible": "Kompatibel:",
  "sparePart.card.single": "Einzelpos.",
  "sort.dateAdded": "Hinzugefügt am",
  "sort.price": "Preis",
  "sort.quantity": "Menge"
};

export default de;
